<template>
    <link-dialog v-model="show"
                 :title="$t('LinkAutoTable.import')"
                 @open="handleOpen"
                 @confirm="p_confirm"
                 @cancel="show = false"
                 disabledHideOnClickShadow="true"
                 width="550px"
                 height="550px">
        <div v-if="step2">
            <step2 :import-dialog="true" :config-id="configId" :context="context" ref="step2" @uploadSuccess="openStep3"></step2>
            <div class="footer-btn">
                <link-button :label="$t('LinkAutoTable.nextStep')" @click="toStep3()"></link-button>
            </div>
        </div>
        <div v-else-if="step3" class="step">
            <step3 :import-dialog="true" :context="context"></step3>
            <div class="footer-btn">
                <link-button :label="$t('LinkAutoTable.prevStep')" @click="backToStep2()"></link-button>
                <link-button :label="$t('LinkAutoTable.nextStep')" @click="toStep4()"></link-button>
            </div>
        </div>
        <div v-else-if="step4" class="step">
            <step4 :import-dialog="true" :context="context"></step4>
            <div class="footer-btn">
                <link-button :label="$t('LinkAutoTable.prevStep')" @click="backToStep3()"></link-button>
                <link-button :label="$t('global.complete')" @click="p_confirm"></link-button>
            </div>
        </div>
    </link-dialog>
</template>

<script>
    // import Step1 from "./step1";
    import Step2 from "./step2";
    import Step3 from "./step3";
    import Step4 from "./step4";
    export default {
        name: 'link-import-modal',
        components: {Step4, Step3, Step2},
        data: function () {
            return {
                onConfirm: null,
                show: false, // 弹出框的显示
                importCode: '',
                step2: false,
                step3: false,
                step4: false,
                configId: 'noMatchId',
			  	context: this,
            };
        },
        methods: {
            /**
             * desc
             * @author huyang
             * @date 2019-02-25 14:59
             * @params
             */
            p_confirm() {
                !!this.onConfirm && this.onConfirm();
                this.show = false;
            },

            /**
             * desc 监控dialog打开之前调用的方法
             * @author huyang
             * @date 2019/1/28 19:55
             * @params
             */
            handleOpen() {
                this.toStep2();
            },

            /**
             * desc 通过编码code查询模版，选择并进入下一步
             * @author huyang
             * @date 2019/2/22 15:11
             * @params
             */
            async toStep2() {
                try {
                    const data = await this.context.$http.post(`/action/${LinkVue.prefixUrl}/publicdataimport/queryByExamplePage`, {
                        pageFlag: false,
                        oauth: 'ALL',
                        filtersRaw: [
                            {
                                id: 'encoded',
                                property: 'encoded',
                                value: `[${this.importCode}]`,
                                operator: 'IN'
                            },
                        ],
                    }, true);
                    if (data.success) {
                        if (data.rows[0]) {
                            this.configId = data.rows[0].id;
                        } else {
                            this.$message.warning(LinkVue.$t('LinkAutoTable.cannotFindImportTemplate'));
                            this.show = false
                        }
                    } else {
                        this.$nav.error(LinkVue.$t('LinkAutoTable.searchImportConfigFail') + ':' + data.result);
                    }
                } catch (e) {
                    this.$nav.error(LinkVue.$t('LinkAutoTable.searchImportConfigFail') + ':' + e);
                }
                if (this.configId != 'noMatchId') {
                    this.step2 = true;
                }
            },

            /**
             * desc
             * @author huyang
             * @date 2019/2/23 15:22
             * @params
             */
            backToStep2() {
                this.step2 = true;
                this.step3 = false;
            },

            /**
             * desc
             * @author huyang
             * @date 2019/2/23 15:22
             * @params
             */
            backToStep3() {
                this.step3 = true;
                this.step4 = false;
            },

            /**
             * desc
             * @author huyang
             * @date 2019/2/23 15:22
             * @params
             */
            toStep3() {
                this.$refs.step2.$refs.upload.submit();
            },

            /**
             * desc
             * @author huyang
             * @date 2019-02-26 18:07
             * @params
             */
            openStep3() {
                this.step2 = false;
                this.step3 = true;
            },

            /**
             * desc
             * @author huyang
             * @date 2019/2/23 15:22
             * @params
             */
            toStep4() {
                this.step3 = false;
                this.step4 = true;
            },
        }
    };
</script>

<style lang="scss">
    @include themeify {
        .link-button.link-button-none.link-button-color-primary {
            color: $color-primary;
        }
        .footer-btn {
            margin: 10px auto;
            text-align: center;
        }
        .step {
            height: 500px;
            overflow-y: auto;
        }
    }
</style>
